/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { displayMessage, getAPI, postAPI } from "../../../utils/common";
import {
  Space,
  Button,
  Card,
  Table,
  Tag,
  Input,
  Select,
  Col,
  Row,
  Modal,
} from "antd";
import {
  MY_BOOKING,
  BOOKING_ADV_PAY,
  BOOKING_ADV_PAY_VERIFY,
  BOOKING_INVOICE,
  BOOKING_PAY,
  BOOKING_PAY_VERIFY,
  IMAGE_BASE_URL,
  BOOKING_ACTION,
  ALL_DYNAMIC_CONTENT,
} from "../../../constants/api";
import { useNavigate } from "react-router-dom";
import {
  CURRENCY,
  getRoomTypeLabel,
  getSegmentLabel,
} from "../../../constants/constent";
import BookingDetailDrawer from "../../booking/BookingDetailDrawer";
import moment from "moment";
import {
  ERROR_MSG_TYPE,
  INFO_MSG_TYPE,
  SUCCESS_MESSAGE,
} from "../../../constants/messages";
import BookingOrderDrawer from "../../booking/BookingOrderDrawer";
import LS_SERVICE from "../../../utils/localStorage";
import { Collapse } from "antd";
const { Panel } = Collapse;

function MyBookingTable() {
  const navigate = useNavigate();

  const [state, setState] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const defaultActiveKeys = filteredData.map((group) =>
    String(group.multi_book_id)
  );
  // Advance Amount
  const [advModalVisible, setAdvModalVisible] = useState(false);
  const [advanceAmount, setAdvanceAmount] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("");
  // Booking View
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [selectedBooking, setSelectedBooking] = useState(null);
  // Booking Order View
  const [isOrderDrawerOpen, setIsOrderDrawerOpen] = useState(false);
  // Booking Cancel
  const [cancelPage, setCancelPage] = useState(null);
  const [isCancelModalVisible, setIsCancelModalVisible] = useState(false);
  const [isCancelPolModalVisible, setIsCancelPolModalVisible] = useState(false);
  const [cancelReason, setCancelReason] = useState("");
  const [selectedBookingId, setSelectedBookingId] = useState(null);

  const getDynamicPages = () => {
    setLoading(true);

    const successFn = function (data) {
      if (data.status === true) {
        data["data"].map((page) => {
          if (page.type === "cancellation") {
            setCancelPage(page);
          }
        });

        setLoading(false);
      } else {
        setCancelPage(null);
        setLoading(false);
      }
    };
    const errorFn = function () {
      setCancelPage(null);
      setLoading(false);
    };
    getAPI(ALL_DYNAMIC_CONTENT, successFn, errorFn, {});
  };

  // Booking View
  const openDrawer = (room) => {
    setSelectedBooking(room);
    setIsDrawerOpen(true);
  };

  const closeDrawer = () => {
    setIsDrawerOpen(false);
    setSelectedBooking(null);
  };

  // Booking Detail View
  const openOrderDrawer = (room) => {
    setSelectedBooking(room);
    setIsOrderDrawerOpen(true);
  };

  const closeOrderDrawer = () => {
    setIsOrderDrawerOpen(false);
    setSelectedBooking(null);
  };

  useEffect(() => {
    getDynamicPages();
    getData();
  }, []);

  const adv_pay_init = (id, advAmount) => {
    setLoading(true);
    let body = {
      id: id,
      total_amount: advAmount,
      payment_method: paymentMethod,
    };
    const successFn = function (data) {
      if (data.status === true) {
        setLoading(false);

        if (data.payment_method === "Online") {
          const options = {
            key: data.options.key,
            amount: data.options.amount * 100,
            currency: data.options.currency,
            name: data.options.name,
            description: data.options.description,
            image: IMAGE_BASE_URL + data.options.image,
            order_id: data.options.order_id,
            prefill: {
              name: data.options.prefill.name,
              email: data.options.prefill.email,
              contact: data.options.prefill.contact,
            },
            handler: function (response) {
              let body = {
                ...response,
                booking_id: id,
                total_amount: advAmount,
              };
              console.log(body);
              const successFn = function (data) {
                displayMessage(SUCCESS_MESSAGE, data.message);
                setAdvanceAmount("");
                setSelectedBooking(null);
                getData();
              };
              const errorFn = function () {
                setLoading(false);
                displayMessage(
                  ERROR_MSG_TYPE,
                  "Unable to do payment verification"
                );
              };
              postAPI(BOOKING_ADV_PAY_VERIFY, body, successFn, errorFn);
            },
            theme: {
              color: "#F37254",
            },
          };
          const razorpay = new window.Razorpay(options);
          razorpay.open();
        } else {
          displayMessage(SUCCESS_MESSAGE, data.message);
          setAdvanceAmount("");
          setSelectedBooking(null);
          getData();
        }
      } else {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, data.message);
      }
    };

    // Error callback
    const errorFn = function () {
      setLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to do payment");
    };

    // Make API call to your backend to initiate Razorpay
    postAPI(BOOKING_ADV_PAY, body, successFn, errorFn);
  };
  const pay_init = (id) => {
    setLoading(true);
    let body = {
      id: id,
    };
    const successFn = function (data) {
      if (data.status === true) {
        setLoading(false);
        displayMessage(SUCCESS_MESSAGE, data.message);

        const options = {
          key: data.options.key,
          amount: data.options.amount * 100,
          currency: data.options.currency,
          name: data.options.name,
          description: data.options.description,
          image: IMAGE_BASE_URL + data.options.image,
          order_id: data.options.order_id,
          prefill: {
            name: data.options.prefill.name,
            email: data.options.prefill.email,
            contact: data.options.prefill.contact,
          },
          handler: function (response) {
            let body = {
              ...response,
              booking_id: id,
            };
            console.log(body);
            const successFn = function (data) {
              displayMessage(SUCCESS_MESSAGE, data.message);
              getData();
            };
            const errorFn = function () {
              setLoading(false);
              displayMessage(
                ERROR_MSG_TYPE,
                "Unable to do payment verification"
              );
            };
            postAPI(BOOKING_PAY_VERIFY, body, successFn, errorFn);
          },
          theme: {
            color: "#F37254",
          },
        };
        const razorpay = new window.Razorpay(options);
        razorpay.open();
      } else {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, data.message);
      }
    };

    // Error callback
    const errorFn = function () {
      setLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to do payment");
    };

    // Make API call to your backend to initiate Razorpay
    postAPI(BOOKING_PAY, body, successFn, errorFn);
  };

  const getData = () => {
    setLoading(true);
    const successFn = function (data) {
      if (data.status === true) {
        setState(data.data);
        setFilteredData(data.data);
        setLoading(false);
      } else {
        displayMessage(INFO_MSG_TYPE, data.message);
        setState([]);
        setFilteredData([]);
        setLoading(false);
      }
    };
    const errorFn = function () {
      setState([]);
      setFilteredData([]);
      setLoading(false);
    };
    postAPI(
      MY_BOOKING,
      LS_SERVICE.get("id") && LS_SERVICE.get("user_type") === "customer"
        ? {
            id: LS_SERVICE.get("id"),
          }
        : {},
      successFn,
      errorFn
    );
  };

  const handleSearch = (value) => {
    setSearchText(value);

    const lowerValue = value.toLowerCase();

    const filtered = state
      .map((group) => {
        const filteredBookings = group.bookings.filter((row) => {
          const orderId = row?.order_id ?? "";
          const bookingStatus =
            row?.booking_status?.toString().toLowerCase() ?? "";
          const roomNo = row?.room_no ?? "";
          const name = row?.customer_name?.toLowerCase() ?? "";
          const phone = row?.user?.phone?.toString() ?? "";

          return (
            orderId.includes(lowerValue) ||
            bookingStatus.includes(lowerValue) ||
            roomNo.includes(lowerValue) ||
            name.includes(lowerValue) ||
            phone.includes(lowerValue)
          );
        });

        if (filteredBookings.length > 0) {
          return {
            ...group,
            bookings: filteredBookings,
          };
        }

        return null;
      })
      .filter((group) => group !== null);

    setFilteredData(filtered);
  };

  // const handleModalOpen = (booking) => {
  //   setSelectedBooking(booking);
  //   setAdvModalVisible(true);
  // };

  const handleModalClose = () => {
    setAdvModalVisible(false);
    setAdvanceAmount("");
    setSelectedBooking(null);
  };

  const handleAdvancePaySubmit = () => {
    if (parseFloat(advanceAmount) <= 0) {
      displayMessage(
        ERROR_MSG_TYPE,
        "Please enter a valid amount for advance payment"
      );
      return;
    }
    adv_pay_init(selectedBooking.id, advanceAmount);
    handleModalClose(); // Close the modal after submitting
  };

  const bookingAction = (id, action_type) => {
    setLoading(true);
    let body = {
      id: id,
      action_type: action_type,
      reason: cancelReason ?? "",
      cancel_by: LS_SERVICE.get("user_type") ?? "",
    };

    const successFn = function (data) {
      if (data.status === true) {
        setLoading(false);
        getData();
        if (action_type === "reject") {
          setIsCancelPolModalVisible(false);
          setIsCancelModalVisible(false);
          setCancelReason("");
          setSelectedBookingId(null);
        }
        displayMessage(SUCCESS_MESSAGE, data.message);
      } else {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, data.message);
      }
    };
    const errorFn = function () {
      setLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to action");
    };
    postAPI(BOOKING_ACTION, body, successFn, errorFn);
  };

  const columns = [
    {
      title: "Sno",
      dataIndex: "ID",
      width: 50,
    },
    // {
    //   title: "Order-ID",
    //   dataIndex: "order_id",
    //   width: 50,
    // },
    // {
    //   title: "Room No",
    //   dataIndex: "room_no",
    //   width: 50,
    // },
    {
      title: "Customer",
      dataIndex: "name",
      width: 100,
    },
    {
      title: "Room Type",
      dataIndex: "room_type",
      width: 100,
    },
    {
      title: "Segment",
      dataIndex: "segment",
      width: 100,
    },
    // {
    //   title: "Mobile",
    //   dataIndex: "phone",
    //   width: 50,
    // },
    // {
    //   title: "Room Price",
    //   dataIndex: "room_price",
    //   width: 50,
    // },
    // {
    //   title: "Total Amount",
    //   dataIndex: "total_amount",
    //   width: 50,
    // },
    // {
    //   title: "Advance Amount",
    //   dataIndex: "advance_amount",
    //   width: 100,
    // },
    {
      title: "Checkin Date",
      dataIndex: "checkin_date",
      width: 150,
    },
    {
      title: "Checkout Date",
      dataIndex: "checkout_date",
      width: 150,
    },
    {
      title: "Booking Status",
      dataIndex: "booking_status",
      width: 50,
    },
    {
      title: "Payment Status",
      dataIndex: "payment_status",
      width: 50,
    },
    {
      title: "Action",
      dataIndex: "Action",
      width: 100,
    },
  ];

  return (
    <>
      <Card
        title="My Booking"
        extra={
          <Space>
            <Input
              placeholder="Search by Name or Room No"
              value={searchText}
              onChange={(e) => handleSearch(e.target.value)}
            />
          </Space>
        }
        bordered={true}
      >
        <Collapse accordion={false} activeKey={defaultActiveKeys}>
          {filteredData.map((group, index) => (
            <Panel
              header={
                <>
                  <p>
                    Booking Group: <b>{group.multi_book_id}</b>
                  </p>
                </>
              }
              key={String(group.multi_book_id)}
              style={{ marginBottom: 16 }}
            >
              <Table
                columns={columns}
                dataSource={group.bookings.map((row, bookingIndex) => ({
                  key: bookingIndex,
                  ID: bookingIndex + 1,
                  room_type: getRoomTypeLabel(row.room_type),
                  room_no_n: row.room_no,
                  booking_status_n: row.booking_status,
                  room_no: <Tag color="green">{row.room_no}</Tag>,
                  name: row.customer_name,
                  segment: getSegmentLabel(row.booking_segment),
                  phone: row.user.phone,
                  room_price: `${CURRENCY} ${row.room_price}`,
                  total_amount: `${CURRENCY} ${row.total_amount}`,
                  advance_amount: `${CURRENCY} ${row.advance_amount}`,
                  checkin_date: moment(row.checkin_date).format(
                    "MMMM Do, YYYY"
                  ),
                  checkout_date: moment(row.checkout_date).format(
                    "MMMM Do, YYYY"
                  ),
                  booking_status: (
                    <Tag
                      color={
                        row.booking_status === "0"
                          ? "yellow"
                          : row.booking_status === "1"
                          ? "green"
                          : row.booking_status === "2"
                          ? "blue"
                          : row.booking_status === "3"
                          ? "red"
                          : "gray"
                      }
                    >
                      {row.booking_status === "0"
                        ? "Pending"
                        : row.booking_status === "1"
                        ? "OnGoing"
                        : row.booking_status === "2"
                        ? "Completed"
                        : row.booking_status === "3"
                        ? "Canceled"
                        : row.booking_status === "4"
                        ? "Accepted"
                        : "Unknown"}
                    </Tag>
                  ),
                  payment_status: (
                    <Tag
                      color={
                        row.payment_status === "2"
                          ? "red"
                          : row.payment_status === "1"
                          ? "green"
                          : row.payment_status === "0"
                          ? "blue"
                          : "gray"
                      }
                    >
                      {row.payment_status === null || row.payment_status === "0"
                        ? "Payment Pending"
                        : row.payment_status === "1"
                        ? "Payment Done"
                        : row.payment_status === "2"
                        ? "Payment Fail"
                        : "Unknown"}
                    </Tag>
                  ),
                  Action: (
                    <Space>
                      <Button
                        loading={loading}
                        disabled={loading}
                        onClick={() => {
                          openDrawer(row);
                        }}
                        danger
                      >
                        Booking Detail
                      </Button>

                      {row.booking_status === "2" &&
                        row.payment_status === "1" && (
                          <Button
                            onClick={() => {
                              const encodedId = btoa(row.id.toString());
                              const url = `${BOOKING_INVOICE}${encodedId}`;
                              window.open(url, "_blank");
                            }}
                            loading={loading}
                            disabled={loading}
                            block
                          >
                            INVOICE
                          </Button>
                        )}

                      {row.booking_status === "1" && (
                        <>
                          <Button
                            loading={loading}
                            disabled={loading}
                            onClick={() => openOrderDrawer(row)}
                            danger
                          >
                            Orders
                          </Button>
                          <Button
                            onClick={() => navigate("/place/order/" + row.id)}
                            loading={loading}
                            disabled={loading}
                            block
                          >
                            Place Order
                          </Button>
                        </>
                      )}

                      {row.payment_method === "Online" &&
                        row.payment_status === "0" && (
                          <Button
                            onClick={() => pay_init(row.id)}
                            loading={loading}
                            disabled={loading}
                            block
                          >
                            Pay
                          </Button>
                        )}
                      {(row.booking_status === "0" ||
                        row.booking_status === "4") && (
                        <>
                          <Button
                            loading={loading}
                            disabled={loading}
                            danger
                            block
                            onClick={() => {
                              setSelectedBookingId(row.id);
                              setIsCancelPolModalVisible(true);
                            }}
                          >
                            Cancel
                          </Button>
                        </>
                      )}
                    </Space>
                  ),
                }))}
                pagination={false}
                size="small"
                scroll={{ x: 240 }}
              />
            </Panel>
          ))}
        </Collapse>
      </Card>

      {/* Cancel Booking Policies Modal */}
      <Modal
        title={cancelPage?.title ?? ""}
        visible={isCancelPolModalVisible}
        onOk={() => {
          setIsCancelPolModalVisible(false);
          setIsCancelModalVisible(true);
        }}
        onCancel={() => {
          setIsCancelPolModalVisible(false);
          setIsCancelModalVisible(false);
        }}
        okText="I Agree"
        cancelText="Close"
      >
        <div
          dangerouslySetInnerHTML={{ __html: cancelPage?.description ?? "" }}
        />
      </Modal>

      {/* Cancel Booking Modal */}
      <Modal
        title="Cancel the booking"
        visible={isCancelModalVisible}
        onOk={() => {
          bookingAction(selectedBookingId, "reject");
        }}
        onCancel={() => {
          setIsCancelPolModalVisible(false);
          setIsCancelModalVisible(false);
        }}
        okText="Confirm Cancel"
        cancelText="Close"
      >
        <p>Please provide a reason for cancellation:</p>
        <Input.TextArea
          rows={4}
          value={cancelReason}
          onChange={(e) => setCancelReason(e.target.value)}
          placeholder="Enter cancellation reason..."
        />
      </Modal>
      {/* Booking View */}
      {isDrawerOpen && selectedBooking && (
        <BookingDetailDrawer
          open={isDrawerOpen}
          onClose={closeDrawer}
          booking={selectedBooking}
        />
      )}
      {/* Booking Order View */}
      {isOrderDrawerOpen && selectedBooking && (
        <BookingOrderDrawer
          open={isOrderDrawerOpen}
          onClose={closeOrderDrawer}
          booking={selectedBooking}
        />
      )}

      <Modal
        title="Advance Payment"
        visible={advModalVisible}
        onCancel={handleModalClose}
        footer={[
          <Button key="cancel" onClick={handleModalClose}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            onClick={handleAdvancePaySubmit}
            loading={loading}
          >
            Submit
          </Button>,
        ]}
      >
        <Space direction="vertical" style={{ width: "100%" }}>
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <b>Amount:</b>
              <Input
                type="number"
                value={advanceAmount}
                onChange={(e) => setAdvanceAmount(e.target.value)}
                placeholder="Enter amount"
                min={0}
              />
            </Col>
            <Col span={12}>
              <b>Payment Method: </b>
              <Select
                value={paymentMethod}
                onChange={(value) => setPaymentMethod(value)}
                style={{ width: "100%" }}
              >
                <Select.Option value="Cash">Cash</Select.Option>
                <Select.Option disabled={advanceAmount === 0} value="Online">
                  Online
                </Select.Option>
              </Select>
            </Col>
          </Row>
        </Space>
      </Modal>
    </>
  );
}

export default MyBookingTable;
